var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { debounce } from 'lodash';
import LoaderCard from '@/components/loader-card/LoaderCard';
import { sanitizeString } from '@/support/String';
let DataTable = class DataTable extends Vue {
    constructor() {
        super(...arguments);
        this.searchDebounce = this.handleSearch();
        this.paginationDebounce = this.handlePagination();
        this.selected = [];
        this.selectedFilter = null;
        this.initialized = false;
        this.$limit = 15;
        this.limitSelected = 15;
        this.editMode = false;
        this.modal = false;
        this.$page = 1;
        this.items = [];
        this.changedItems = [];
        this.itemCache = {};
        this.total = 0;
        this.lastPage = 1;
        this.isLoading = true;
        this.showLoaderCard = false;
        this.TableHeader = [
            {
                text: 'Name',
                value: 'name',
            },
        ];
        this.pagination = {
            sortBy: 'name',
            rowsPerPage: 5,
        };
        this.name = {
            singular: 'Item',
            plural: 'Items',
        };
        this.visible = {
            search: true,
            total: true,
            limit: true,
            pagination: true,
            checkboxes: true,
        };
        this.searchInput = '';
        this.tableActions = [];
        this.tableFilters = [];
        this.dateModals = {};
    }
    optionsChanged(options, oldOptions) {
        if (this.initialized) {
            this.initiliaze();
        }
    }
    mounted() {
        if (this.default) {
            this.selected = this.default;
        }
        else {
            this.selected = [];
        }
        document.addEventListener('datatable:hook', (event) => {
            if (event.detail) {
                event.detail(this);
            }
        });
        this.initiliaze();
    }
    initiliaze() {
        this.items = [];
        this.total = 0;
        this.isLoading = true;
        this.$page = this.page;
        this.$limit = this.limit;
        this.limitSelected = this.$limit;
        this.pagination.rowsPerPage = this.$limit;
        this.visible = { ...{}, ...this.visible, ...this.visibility };
        this.TableHeader = [];
        this.tableActions = [];
        this.tableFilters = [];
        if (this.options.headers !== undefined) {
            this.TableHeader = this.options.headers;
        }
        if (this.options.actions !== undefined) {
            this.tableActions = this.options.actions;
            const hasActions = this.TableHeader.findIndex((header) => header.value === '$actions') !== -1;
            if (this.tableActions.length > 0 && !hasActions) {
                this.TableHeader.push({ text: '', value: '$actions' });
            }
        }
        if (this.options.filters !== undefined) {
            this.tableFilters = this.options.filters;
        }
        if (this.options.sort !== undefined && this.options.sort.key !== undefined) {
            this.$sort = this.options.sort;
        }
        if (this.options.name !== undefined) {
            this.name = { ...this.name, ...this.options.name };
        }
        this.fetchSource();
    }
    resetSelected() {
        this.selected = [];
    }
    fetchSource() {
        this.isLoading = true;
        if (this.$sort && this.$sort.key) {
            this.options.model.sort(this.$sort.key, this.$sort.order);
        }
        this.options.model
            .limit(this.$limit)
            .page(this.$page)
            .filter('search', this.searchInput)
            .all()
            .then((items) => {
            if (items.length && !items[0].name) {
                items.forEach((item, index) => {
                    item.name = index;
                });
            }
            if (this.isStudentEventOverview) {
                this.items = items.map((item) => {
                    const user = item.user;
                    user.is_chosen = item.is_chosen;
                    user.is_default = item.is_default;
                    user.is_mandatory = item.is_mandatory;
                    user.is_pickable = item.is_pickable;
                    return user;
                });
            }
            else {
                this.items = items;
            }
            this.total = items[0] !== undefined ? items[0].meta.total : 0;
            this.lastPage = items[0] !== undefined ? items[0].meta.last_page : 1;
            this.createDateModals();
            this.initialized = true;
            this.isLoading = false;
        })
            .catch((error) => {
            this.isLoading = false;
        });
    }
    createDateModals() {
        const fields = [];
        this.options.headers.forEach((header, index) => {
            if (header.type && header.type === 'date') {
                fields.push(header.value);
            }
        });
        this.items.forEach((item) => {
            fields.forEach((field) => {
                const key = `${item.id}_${field}`;
                this.$set(this.dateModals, key, false);
            });
        });
    }
    refresh() {
        this.fetchSource();
    }
    deleteItem(item) {
        this.isLoading = true;
        item.delete().then((resonse) => {
            this.fetchSource();
        });
    }
    toggleAll() {
        if (this.selected.length) {
            this.selected = [];
        }
        else {
            this.selected = this.items.slice();
        }
    }
    handlePagination() {
        return debounce((page) => {
            this.$page = page;
            this.fetchSource();
        }, 300);
    }
    handleAction(action, item) {
        action(this, item);
        return;
    }
    handleVisibility(visible, item) {
        return visible(this, item);
    }
    handleIcon(action, item) {
        return action(this, item);
    }
    setItemChanged(item) {
        if (!this.changedItems.includes(item.id)) {
            this.changedItems.push(item.id);
            this.isLoading = false;
        }
    }
    resetDateField(item, property) {
        if (!this.itemCache[item.id]) {
            return;
        }
        item[property] = this.itemCache[item.id][property];
        this.dateModals[`${item.id}_${property}`] = false;
    }
    cancelEdit() {
        Object.keys(this.itemCache).forEach((key) => {
            const item = this.items.find((level) => {
                return level.id === key;
            });
            if (!item) {
                return;
            }
            Object.keys(this.itemCache[key]).forEach((property) => {
                item[property] = this.itemCache[key][property];
            });
        });
        this.clearChangedItems();
        this.editMode = false;
    }
    handleTableEdit() { }
    minDate(header) {
        if (!header.min) {
            return '';
        }
        return header.min;
    }
    maxDate(header) {
        if (!header.max) {
            return '';
        }
        return header.max;
    }
    handleSearch() {
        return debounce((searchInput) => {
            this.$page = 1;
            this.fetchSource();
        }, 400);
    }
    createItemCache() {
        this.clearItemCache();
        this.items.forEach((item) => {
            const itemProperties = {};
            this.TableHeader.forEach((header) => {
                if (header.value !== '$actions' && header.editable) {
                    itemProperties[header.value] = item[header.value];
                }
            });
            this.itemCache[item.id] = itemProperties;
        });
    }
    update() {
        let callCounter = 0;
        const changed = this.items.filter((item) => {
            if (this.changedItems.length === 0) {
                this.showLoaderCard = false;
                this.isLoading = false;
                this.editMode = false;
                return false;
            }
            this.showLoaderCard = true;
            return this.changedItems.includes(item.id);
        });
        changed.forEach((item) => {
            item
                .update()
                .then((model) => {
                item = model;
                callCounter += 1;
                if (callCounter >= changed.length) {
                    this.showLoaderCard = false;
                    this.isLoading = false;
                    this.clearChangedItems();
                    this.editMode = false;
                    this.$emit('data-update');
                    this.refresh();
                }
            })
                .catch((error) => {
                this.showLoaderCard = false;
            });
        });
    }
    visibleForRole(roles) {
        if (!roles) {
            return true;
        }
        return this.$store.state.Auth.hasRole(roles);
    }
    isActionVisible(visible, item) {
        if (typeof visible === 'boolean') {
            return true;
        }
        if (typeof visible === 'function') {
            return this.handleVisibility(visible, item);
        }
        if (visible === undefined) {
            return true;
        }
    }
    clearChangedItems() {
        this.changedItems = [];
    }
    clearItemCache() {
        Object.keys(this.itemCache).forEach((key) => {
            delete this.itemCache[key];
        });
    }
    isFunction(object) {
        return object && {}.toString.call(object) == '[object Function]';
    }
    changeSorting(sortable) {
        if (!sortable) {
            return;
        }
        if (sortable.order === 'ASC') {
            sortable.order = 'DESC';
        }
        else {
            sortable.order = 'ASC';
        }
        this.$sort = sortable;
        this.fetchSource();
    }
    isSortable(header) {
        if (!header.sortable) {
            return false;
        }
        return true;
    }
    getExtraClass(object) {
        const avatarClass = object.value === 'avatar' ? 'avatar-column' : '';
        if (object.class) {
            if (this.isFunction(object)) {
                return [object.class(), avatarClass];
            }
            else {
                return [object.class, avatarClass];
            }
        }
    }
    selectionChange(value, oldValue) {
        if (!this.multiple && this.selected.length > 1) {
            this.selected = [this.selected[this.selected.length - 1]];
        }
        this.$emit('input', this.selected);
    }
    // @Watch('default')
    // protected defaultChanged(value: any, oldValue: any) {
    //   if (value !== null && value !== undefined && value.length > 0 && this.selected !== value) {
    //     this.selected = value;
    //   }
    // }
    selectedFilterChange(value, oldValue) {
        this.options.model.filter(value.type.toLowerCase(), value.value);
        this.fetchSource();
    }
    limitChanged(limit, oldLimit) {
        if (limit === null) {
            return;
        }
        this.$limit = limit;
        this.$page = 1;
        this.fetchSource();
    }
    editModeToggled(isEditting) {
        if (isEditting) {
            this.createItemCache();
        }
    }
    headerClasses(header) {
        const defaultClasses = {
            'icon-column': header.value === 'icon',
            'color-column': header.value === 'color',
            'avatar-column': header.value === 'avatar',
            'actions-column': header.value === '$actions',
            'sortable-column': this.isSortable(header),
            'asc': (this.isSortable(header) && header.sortable.order === 'ASC'),
            'desc': (this.isSortable(header) && header.sortable.order === 'DESC'),
        };
        const customClasses = header.class ? { [header.class]: true } : {};
        return { ...defaultClasses, ...customClasses };
    }
    columnStyles(header) {
        const actions = header.value === '$actions' ? { textAlign: 'right' } : {};
        return {
            ...actions,
            ...(header.style ? header.style : {}),
        };
    }
    clearSelected() {
        this.selected = [];
    }
    clearSelect(clear) {
        if (clear) {
            this.selected = [];
            this.searchInput = '';
            this.fetchSource();
            this.$emit('cleared');
        }
    }
    sanitizeString(value) {
        return sanitizeString(value, true);
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Object)
], DataTable.prototype, "options", void 0);
__decorate([
    Prop({ default: true }),
    __metadata("design:type", Boolean)
], DataTable.prototype, "multiple", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DataTable.prototype, "isStudentEventOverview", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DataTable.prototype, "isNewChatOverview", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DataTable.prototype, "editable", void 0);
__decorate([
    Prop({ default: null }),
    __metadata("design:type", Number)
], DataTable.prototype, "limit", void 0);
__decorate([
    Prop({ default: 1 }),
    __metadata("design:type", Number)
], DataTable.prototype, "page", void 0);
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", Object)
], DataTable.prototype, "visibility", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], DataTable.prototype, "clear", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], DataTable.prototype, "default", void 0);
__decorate([
    Watch('options'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DataTable.prototype, "optionsChanged", null);
__decorate([
    Watch('selected'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], DataTable.prototype, "selectionChange", null);
__decorate([
    Watch('selectedFilter'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, String]),
    __metadata("design:returntype", void 0)
], DataTable.prototype, "selectedFilterChange", null);
__decorate([
    Watch('limitSelected'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Number]),
    __metadata("design:returntype", void 0)
], DataTable.prototype, "limitChanged", null);
__decorate([
    Watch('editMode'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DataTable.prototype, "editModeToggled", null);
__decorate([
    Watch('clear'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], DataTable.prototype, "clearSelect", null);
DataTable = __decorate([
    Component({
        components: {
            SelectFilter,
            LoaderCard,
        },
    })
], DataTable);
export default DataTable;
